import React from 'react'
import { Button, Spinner } from 'react-bootstrap'

const LoadMoreButton = ({
    onClick = () => {},
    isBusy
}) => {

    const renderContent = () => {
        if (!isBusy) {
            return (<React.Fragment>More</React.Fragment>)
        }
        return (
            <Spinner animation="grow" variant="primary" size="sm"/>
        )
    }

    return (
        <Button
            disabled={isBusy}
            size="sm"
            block={true}
            variant="outline-primary"
            onClick={() => onClick()}
        >
            {renderContent()}
        </Button>
    )
}

export default LoadMoreButton
